import React from 'react';
import { toDateTimeString } from '../../../util/DateUtility';
import { formatPhoneNumber } from '../../../util/EfupUtility';
import './PartyInfo.css';


export default function PartyInfo(props) {
    const index = props.index;
    const party = props.party;

    return (
        <div className="efup-side-panel-line" >
        <table className="efup-party-info-table table table-borderless" >
            <tbody>
                <tr>
                    <td className="efup-side-panel-label" data-testid={`efup-overview-tab-party-name-label-${index}`}>{party.isVendor ? "Vendor Name" : "Name"}:</td>
                    <td className="efup-side-panel-data" data-testid={`efup-overview-tab-party-name-data-${index}`}>{party?.name ? party.name : "Not Available"}</td>
                </tr>
                {party.isVendor ?
                    <tr>
                        <td className="efup-side-panel-label" data-testid={`efup-overview-tab-party-vendor-code-label-${index}`}>Vendor ID:</td>
                        <td className="efup-side-panel-data" data-testid={`efup-overview-tab-party-vendor-code-data-${index}`}>
                            {party?.vendorCode ? party.vendorCode : "N/A"}
                        </td>
                    </tr>
                    :<></>
                }
                <tr>
                    <td className="efup-side-panel-label" data-testid={`efup-overview-tab-party-email-label-${index}`}>Email:</td>
                    <td className="efup-side-panel-data" data-testid={`efup-overview-tab-party-email-data-${index}`}>
                        {party?.email ?
                            <a className="overview-party-email" href={`mailto:${party.email}`}>{party.email}</a>
                            : "N/A"
                        }
                    </td>
                </tr>
                <tr>
                    <td className="efup-side-panel-label" data-testid={`efup-overview-tab-party-phone-number-label-${index}`}>Phone Number:</td>
                    <td className="efup-side-panel-data" data-testid={`efup-overview-tab-party-phone-number-data-${index}`}>
                        {party?.phoneNumber ?
                            <a className="overview-party-phone" href={`tel:${party.phoneNumber}`}>{formatPhoneNumber(party.phoneNumber)}</a> 
                            : "N/A"
                        }
                    </td>
                </tr>
                <tr>
                    <td className="efup-side-panel-label" data-testid={`efup-overview-tab-party-key-expiration-label-${index}`}>Key Expiration:</td>
                    <td className="efup-side-panel-data" data-testid={`efup-overview-tab-party-key-expiration-data-${index}`}>{party.expirationDate ? toDateTimeString(party.expirationDate) : "N/A"}</td>
                </tr>
            </tbody>
        </table>
        </div>
    );
}
